import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { clearPISessionStorage } from "../../../helpers/shared/sessionStorage";
import ManulifeFooter from "../components/ManulifeFooter";
import Cancel from "../components/Cancelled";
import RenewalHeader from "../components/RenewalHeader";
const Cancelled = () => {
  useEffect(() => {
    clearPISessionStorage("professional_indemnity/manuliferenewal");
  }, []);
  const { t } = useTranslation("pages", { keyPrefix: "professionalIndemnity.renewal" });

  return (
    <div className="flex flex-col justify-start min-h-[inherit]">
      <RenewalHeader />
      <Cancel t={t} />
      <ManulifeFooter />
    </div>
  );
};

export default Cancelled;
